import * as React from "react";
import styled from "react-emotion";
import ArticleImage from "../ArticleImage";
import ArticleVideo from "../ArticleVideo";
import ArticleText from "../ArticleText";
import ArticleHeading from "../ArticleHeading";
import ArticleQuote from "../ArticleQuote";
import PhotoGrid from "../PhotoGrid";
import { theme, mqMin } from "../../styles/theme";

const Wrap = styled.div`
  margin-top: ${theme.space3};
  margin-bottom: ${theme.space4};
`;

const ArticleSwitch = ({ slice }) => {
  switch (slice.__typename) {
    case "PrismicArticleBodyText":
      return <ArticleText slice={slice} />;
    case "PrismicArticleBodyHeading":
      return <ArticleHeading slice={slice} />;
    case "PrismicArticleBodyQuote":
      return <ArticleQuote slice={slice} />;
    case "PrismicArticleBodyImage":
      return <ArticleImage slice={slice} />;
    case "PrismicArticleBodyImageGallery":
      return (
        <PhotoGrid photos={slice.items} columns={slice.number_of_columns} />
      );
    case "PrismicArticleBodyVideo":
      return <ArticleVideo slice={slice} />;

    default:
      return null;
  }
};

const ArticleSlices = ({ slices }) => {
  return (
    <Wrap>{slices.map((s, k) => <ArticleSwitch slice={s} key={k} />)}</Wrap>
  );
};

export default ArticleSlices;



// WEBPACK FOOTER //
// ./src/components/ArticleSlices/index.js